module.exports = __webpack_public_path__ + "media/images/flags/4x3/mmr-f6c8607e09a9402a963524bbe8a0d047.svg";